export const editConnectorApiErrors: Record<string, string> = {
  NOT_FOUND: 'shadowNotFound',
  EVSE_ID_NOT_UNIQUE: 'evseIdAlreadyTaken',
};
